import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LockOpenIcon from '@mui/icons-material/LockOpen';

import { SelectButton, SelectButtonText, Title } from "./styles";

export type valueEntryProp = {
  label: string;
  value?: string;
  checked?: boolean;
  type?: string;
};
export type valueProp = Array<valueEntryProp>;

interface Props {
  userPermissions?: string[];
  className?: any;
  inputText?: string;
  value: valueProp;
  setValue?: Dispatch<SetStateAction<valueEntryProp[]>>;
  onAddClick?: (textInput: string) => void;
  onItemCheckedChange?: (varName: string, newVarValue: boolean) => void;
  title?: string;
}
const CustomSelection: React.FC<Props> = ({
  userPermissions,
  className,
  inputText,
  value,
  title,
  setValue,
  onAddClick,
  onItemCheckedChange,
}) => {
  const [addInputText, setAddInputText] = useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <span className={className} style={{ margin: "1px" }}>
      {title && <Title>{title}</Title>}
      <SelectButton
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(event: any) => {
          handleClick(event);
        }}
        style={{ width: "150px" }}
      >
        <LockOpenIcon />
        <SelectButtonText>
          {value
            .filter((vl) => vl.checked)
            .map((vl) => vl.label)
            .join(", ")}
        </SelectButtonText>
        <KeyboardArrowDownIcon style={{ color: "#374957 !important" }} />
      </SelectButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <div style={{ width: "200px", height: "100px", overflowY: "scroll" }}>
            <FormGroup>
              {value.map((currValue) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(evt) => {
                        if (onItemCheckedChange) {
                          onItemCheckedChange(
                            evt.target.value,
                            evt.target.checked
                          );
                        }
                        if (setValue) {
                          const posToEdit = value
                            .map((val) => val.value)
                            .indexOf(evt.target.value);
                          let arrToEdit = [...value]; //Pass value by copy, not reference
                          arrToEdit[posToEdit].checked = evt.target.checked;
                          setValue(arrToEdit);
                        }
                      }}
                      checked={currValue.checked}
                    />
                  }
                  label={currValue.label}
                  value={currValue.value ? currValue.value : currValue.label}
                />
              ))}
            </FormGroup>
          </div>
        </MenuItem>
        {inputText && (
          <MenuItem onKeyDown={(e) => e.stopPropagation()}>
            <TextField
              id="outlined-basic"
              label={inputText}
              variant="outlined"
              style={{ marginRight: "10px" }}
              onChange={(evt: any) => {
                setAddInputText(evt.target.value);
              }}
              value={addInputText}
            />
            <Button
              variant="contained"
              onClick={() => {
                if (onAddClick) {
                  onAddClick(addInputText);
                  setAddInputText("");
                }
              }}
            >
              Add
            </Button>
          </MenuItem>
        )}
      </Menu>
    </span>
  );
};

export default CustomSelection;
